export const VIDEO_TYPE_OPTIONS = [
  { value: 'youtube', label: 'YouTube' },
  { value: 'iframe', label: 'Iframe Embed' },
  { value: 'other', label: 'Other URL' },
  { value: 'mp4', label: 'Direct MP4 URL' },
];

const ensureTrailingSlash = (value = '') => (value.endsWith('/') ? value : `${value}/`);

const isAbsoluteUrl = (value = '') => /^https?:\/\//i.test(value);

export const isManagedUploadPath = (value = '') =>
  typeof value === 'string' && value.replace(/\\/g, '/').startsWith('video_reels/');

export const isActiveValue = (value) => {
  if (value === 0 || value === false) {
    return false;
  }

  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized !== '0' && normalized !== 'false' && normalized !== 'inactive' && normalized !== 'no';
};

export const getInitialVideoMode = (reel = {}) => (isManagedUploadPath(reel?.video_url) ? 'upload' : 'url');

export const getInitialFormValues = (reel = {}) => {
  const isUploadVideo = getInitialVideoMode(reel) === 'upload';
  const isUploadThumbnail = isManagedUploadPath(reel?.thumbnail);

  return {
    title: reel?.title || '',
    description: reel?.description || '',
    video_url: isUploadVideo ? '' : reel?.video_url || '',
    video_type: isUploadVideo ? 'mp4' : reel?.video_type || 'youtube',
    thumbnail_url: isUploadThumbnail ? '' : reel?.thumbnail || '',
    is_active: isActiveValue(reel?.is_active) ? 1 : 0,
    video: null,
    thumbnailFile: null,
  };
};

export const getAssetUrl = (value = '') => {
  if (!value) {
    return '';
  }

  if (isAbsoluteUrl(value)) {
    return value;
  }

  const normalized = String(value).replace(/\\/g, '/').replace(/^\/+/, '');
  const relativeUploadsBase = process.env.REACT_APP_BACKEND_URL_REL
    ? ensureTrailingSlash(process.env.REACT_APP_BACKEND_URL_REL)
    : '';

  if (relativeUploadsBase && isManagedUploadPath(normalized)) {
    return `${relativeUploadsBase}${normalized}`;
  }

  const backendBase = process.env.REACT_APP_BACKEND ? ensureTrailingSlash(process.env.REACT_APP_BACKEND) : '';

  if (!backendBase) {
    return normalized;
  }

  if (normalized.startsWith('uploads/')) {
    return `${backendBase}${normalized}`;
  }

  if (isManagedUploadPath(normalized)) {
    return `${backendBase}uploads/${normalized}`;
  }

  return `${backendBase}${normalized}`;
};

export const getYoutubeEmbedUrl = (value = '') => {
  if (!value) {
    return '';
  }

  try {
    const url = new URL(value);

    if (url.hostname.includes('youtu.be')) {
      const videoId = url.pathname.replace('/', '');
      return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    }

    if (url.hostname.includes('youtube.com')) {
      const videoId = url.searchParams.get('v');
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }

      if (url.pathname.startsWith('/embed/')) {
        return value;
      }
    }
  } catch (error) {
    return '';
  }

  return '';
};

export const isVideoFileUrl = (value = '') =>
  /\.(mp4|webm|ogg)(\?.*)?$/i.test(value) || isManagedUploadPath(value);
